<template>
  <PrintPage :pageNumber="pageNumber" :pageCount="pageCount">
    <template v-slot:header>
      <slot>
        <div class="header-grid"></div>
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h3>{{ $t('installationTeamDocumentation') }} - 5. {{ $t('inverter') }}</h3>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('inverterEState') }}</div>
        <div>
          {{ $t(project.enpalReport.inverterEState) }}
        </div>
      </div>

      <div class="two-column-grid">
        <div>{{ $t('inverterAttachment_F') }}</div>
        <div>
          <img
            v-if="project.enpalReport.inverterAttachment_F"
            :src="project.enpalReport.inverterAttachment_F.path"
          />
        </div>
      </div>
      <div class="one-column">
        WR-Sicherheitsabstände:
        <ul>
          <li>22 cm seitlich</li>
          <li>32 cm oben</li>
          <li>42 cm unten</li>
          <li>100cm vorne</li>
        </ul>
      </div>

      <div class="two-column-grid" v-for="i in range(1, 3)" :key="i">
        <div>F{{ i }}) {{ $t('inverterAttachmentsAdditional_F') }} {{ $t('image') }} {{ i }}</div>
        <div>
          <img
            v-if="project.enpalReport.inverterAttachmentsAdditional_F[i - 1]"
            :src="project.enpalReport.inverterAttachmentsAdditional_F[i - 1].path"
            alt=""
          />
        </div>
      </div>
    </div>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';

export default {
  components: {
    PrintPage,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: 1 },
    pageNumber: { type: Number, default: 0 },
  },
  methods: {
    range(min, max) {
      const array = [];
      let j = 0;
      for (var i = min; i <= max; i++) {
        array[j] = i;
        j++;
      }
      return array;
    },
  },
};
</script>

<style src="./ReportPrintPage.scss" lang="scss" />
